import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { SiteType } from '../../../../environments/site-type';

@Component({
  selector: 'app-by-site-type',
  templateUrl: './by-site-type.component.html',
})
export class BySiteTypeComponent {
  siteType = environment.siteType;

  get isBus() {
    return this.siteType === SiteType.BUS;
  }

  get isShip() {
    return this.siteType === SiteType.SHIP;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/by-site-type/by-site-type.component.ts